module.exports = __webpack_public_path__ + "img/西瓜12.c55269ee.png";